import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

var AccountBtn = function AccountBtn(_ref) {
  var toggleAccountModal = _ref.toggleAccountModal,
      id = _ref.id,
      formType = _ref.formType,
      children = _ref.children;

  if (id) {
    return ReactDOM.createPortal(React.createElement(
      'button',
      {
        onClick: function onClick() {
          return toggleAccountModal({ active: true, formType: formType });
        }
      },
      children
    ), document.getElementById(id));
  } else {
    return null;
  }
};

AccountBtn.propTypes = {
  toggleAccountModal: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  formType: PropTypes.oneOf(['', 'LOGIN', 'REGISTER', 'RECOVER', 'WISHLIST']),
  children: PropTypes.string.isRequired
};

export default AccountBtn;